
function InterventionDataExport() {
    /// <summary>
    /// This object provides client-side functions for the Intervention/DataExport.vb <br/>
    /// <br/>
    /// Author: ARF<br />
    /// Date: 27.6.2018<br />
    /// Copyright ©: EUDT GmbH 2018 <br />
    /// Version-History:<br />
    /// **********************************************************************<br />
    /// *** v1.0.0 - 27.6.2018                                               *<br />
    /// **********************************************************************<br />
    /// * - basic functionality                                              *<br />
    /// **********************************************************************<br />
    /// </summary>
}

InterventionDataExport.prototype = new vcTemplate();

InterventionDataExport.prototype.init = function () {
    /// <summary>
    /// This function inits the menu click handler. 
    /// </summary>
    var me = this;
    var bInit = true;
    try {
        if (me.error) { return false; }
        me.showInfo("", "", false);
       
        //set some widths and heights
        me.visual.find(".list, .entry").height(me.height);
        me.visual.find(".entry").width(parseInt(me.width - me.visual.find(".list").width() -28));
        me.visual.find("#vc-list-selection").height(parseInt(me.height - (me.visual.find(".vc-filter").height() + me.visual.find(".vc-date").height() + me.visual.find(".vc-list.intervention").height() + 46)));


        //init vcfilter and vcdate
        me.visual.find("#div-filter").vcFilter({ callback: function () { me.filter(); } });
        me.visual.find(".vc-date").vcDate({
            mode: "Range", align: "right", interval: 1, langID: me.userLangidForCulture,
            defaultRange: { from: moment(moment().add(-30, 'days'), "dd.MM.yyyy"), to: moment(moment(), "dd.MM.yyyy") },
            callback: function (obj) {
            if (bInit === false) {me.fetchEntries(obj);}
            bInit = false;
        } });

        //init click handler
        me.visual.find("#vc-list-selection").off("click", ".vc-list-item").on("click", ".vc-list-item", function (e) { me.select($(e.target)) });
        me.visual.find("#div-btn-generate").off("click").on("click", function () { me.export() });


        return true;
    } catch (ex) { me.writeError('init', ex); return false }

}

InterventionDataExport.prototype.fetchEntries = function (obj) {
    /// <summary>
    /// This function fetches new entries, generates the entry list and validates it <br/>
    /// </summary>
    var me = this;
    var param;
    var i;
    var li;
    var list;
    var entry;
    try {
        if (me.error) { return false; }
        //show entry list - hide right side
        me.toggleList(true);

        list = me.visual.find("#vc-list-selection");
        list.html(me.vcC.getLoadingIcon());

        param = { "type": 0, "StartDate": obj.returnDates.from, "EndDate": obj.returnDates.to }
        window.VisualCoreService.getData(me.vcvid, me.vcgid, getCurrentTimestamp(), 0, 0, '', '', 1, 2, JSON.stringify(param),
        function (result) {
            if (result === null) { me.showMessage(me.resources.err_loadData, true); }
          
            if (result.rows === null) {
                list.html("<br/>");
                list.append($("<div>").addClass("note").html(me.resources.noEntriesExist));
                return true;
            }
            //save the entries for later
            me.entries = result;
            //add the entries
            list.html("");
            for (i = 0; i < me.entries.rows.length; i++) {
                li = $("<li>").addClass("vc-list-item");
                li.data("id", me.entries.rows[i].id);
                li.data("data", me.entries.rows[i]);

                entry = $("<div>").addClass("entry-date");
                entry.append($("<div>").addClass("entry-caption").html(me.entries.rows[i].name));
                entry.append(moment(me.entries.rows[i].starttime).toDate().format("dd.MM.yyyy"));
                if (moment(me.entries.rows[i].starttime).toDate().format("dd.MM.yyyy") !==
                    moment(me.entries.rows[i].endtime).toDate().format("dd.MM.yyyy")) {
                    entry.append(" - " + moment(me.entries.rows[i].endtime).toDate().format("dd.MM.yyyy"));
                }
                entry.append($("<div>").addClass("entry-type").html(me.entries.rows[i].intervention_type));
                li.append($("<div>").html(entry));
                list.append(li);  
            }
            me.filter();
            return true;
        });

        return true;
    } catch (ex) {
        me.writeError('fetchEntries', ex);
        return false;
    }

};

InterventionDataExport.prototype.select = function (obj) {
    /// <summary>
    /// This function fetches information and the signal list for one single event <br/>
    /// </summary>
    var me = this;
    var param;
    var i;
    var li;
    var list;
    var col;
    var data;
    try {
        if (me.error) { return false; }
        if (obj.hasClass("vc-list-item") === false) {
           
          obj = obj.parents(".vc-list-item");
        }
        //show right side 
        me.toggleList(false);

        me.selectedEvent = obj;
        data = obj.data("data");
       
        me.visual.find("#div-name").html(data.name);
        me.visual.find("#div-description").html(data.description);
        me.visual.find("#div-startdate").html(moment(data.starttime).toDate().format("dd.MM.yyyy HH:mm") + " " + me.resources.clock );
        me.visual.find("#div-enddate").html(moment(data.endtime).toDate().format("dd.MM.yyyy HH:mm") + " " + me.resources.clock);
       
        me.visual.find("#div-btn-generate").addClass("active");
        me.visual.find("#div-export-link").html("");

       //reset the height of the signal list based on the height of the entry infos
        me.visual.find("#vc-list-signals").height(parseInt(me.height - (me.visual.find("#div-entry-info").height() + 50)));

        list = me.visual.find("#vc-list-signals");
        list.html(me.vcC.getLoadingIcon());

        param = { "type": 1, "iid": parseInt(obj.data("id")), "StartDate": moment(data.starttime).toDate().format("dd.MM.yyyy HH:mm"), "EndDate": moment(data.endtime).toDate().format("dd.MM.yyyy HH:mm") }
        window.VisualCoreService.getData(me.vcvid, me.vcgid, getCurrentTimestamp(), 0, 0, '', '', 1, 2, JSON.stringify(param),
        function (result) {
            list.html("");
            if (result === null) {
                list.html("<br/>").append($("<div>").addClass("error").html(me.resources.noEntriesExist));
                return true;
            }


            for (i = 0; i < result.rows.length; i++) {
                li = $("<li>").addClass("vc-list-item");

                if (result.rows[i].valid > 0) { li.addClass("error"); }

                col = $("<div>").addClass("vc-list-col");
                col.append($("<div>").addClass("vc-list-col-element col0 vc-grid-2col vc-grid-margin-right").html(result.rows[i].name ));
                col.append($("<div>").addClass("vc-list-col-element col1 vc-grid-1col").html(parseFloat(result.rows[i].value.replace(",", ".")).toFixed(2).replace(".", ",")));
                col.append($("<div>").addClass("vc-list-col-element col2 vc-grid-1col").html(" [" + result.rows[i].dims + "]"));
                col.append($("<div>").addClass("vc-list-col-element col3 vc-grid-4col").html(result.rows[i].signals));
               
                li.append(col);

                if (result.rows[i].valid >0) {
                    li.append($("<br/>"));
                    if (result.rows[i].valid === 1) { li.append($("<div>").addClass("").html("<hr/><b>" + me.resources.notValid + "</b>")); }
                    if (result.rows[i].valid === 2) { li.append($("<div>").addClass("").html("<hr/><b>" + me.resources.notPlausible + "</b>")); }
                    if (result.rows[i].valid === 3) { li.append($("<div>").addClass("").html("<hr/><b>" + me.resources.notSummable + "</b>")); }
                }
                list.append(li);
            }
           
            return true;
        });

        return true;
    } catch (ex) {
        me.writeError('select', ex);
        return false;
    }

};

InterventionDataExport.prototype.export = function () {
    /// <summary>
    /// This function fetches the link for the generates xls file <br/>
    /// </summary>
    var me = this;
    var param;
 
    var obj;
    try {
        if (me.error) { return false; }

        if (me.visual.find("#div-btn-generate").hasClass("active")===false) {return false}

        obj = me.selectedEvent;
        var data = obj.data("data");
        me.visual.find("#div-btn-generate").removeClass("active");
        me.visual.find("#div-export-link").html("<b><img src='../../images/visualcore/loading.gif' style='height:15px'/> " + me.resources.generateExport + "<b>");

        param = { "type": 1, "iid": parseInt(obj.data("id")), "StartDate": moment(data.starttime).toDate().format("dd.MM.yyyy HH:mm"), "EndDate": moment(data.endtime).toDate().format("dd.MM.yyyy HH:mm") }
    
        window.VisualCoreService.exportData(me.vcvid, me.vcgid, getCurrentTimestamp(), 0, 0, '', '', 1, 2, JSON.stringify(param),
        function (result) {
            console.info(result.length);
            if (result.length === 0) {
                me.visual.find("#div-export-link").html(me.resources.noEntriesExist);
                return true;
            }
            
            me.visual.find("#div-export-link").html($("<a>").attr("href", result).html(me.resources.download));
            me.visual.find("#href-export").attr("href", result);         
            return true;
        });

        return true;
    } catch (ex) {
        me.writeError('export', ex);
        return false;
    }

};

InterventionDataExport.prototype.toggleList = function (bShow) {
    /// <summary>
    /// This function shows/hides the right side menus
    /// </summary>
    var me = this;
    try {
        if (me.error) { return false; }

        if (bShow) {
            me.visual.find("#div-info").show();
            me.visual.find("#div-entry-info, #div-signal-list").hide();
        } else {
            me.visual.find("#div-info").hide();
            me.visual.find("#div-entry-info, #div-signal-list").show();
        }

        return true;
    } catch (ex) { writeError('toggleImportList', ex); return false }
};

InterventionDataExport.prototype.filter = function () {
    /// <summary>
    /// This function handles the filter
    /// </summary>
    var me = this;
    try {
        if (me.error) { return false; }

        //hide all
        me.visual.find("#vc-list-selection .vc-list-item").removeClass("found").data("counter", 0).hide();
        //we add the 'found' class to all items we want to filter based on the vcfilter tags
        me.setTagFilter(".vc-filter", "#vc-list-selection .vc-list-item", "found");
        me.visual.find("#vc-list-selection .vc-list-item.found").show();
        me.visual.find("#vc-list-selection .vc-list-item").removeClass("alt");
        me.visual.find("#vc-list-selection .vc-list-item.found:even").addClass("alt");

        return true;
    } catch (ex) { me.writeError('filter', ex); return false }
};

InterventionDataExport.prototype.specificInfoHandling = function (bError) {
    /// <summary>
    /// This function  hides/fades out content on error state. 
    /// </summary>
    var me = this;
    try {
        if (bError) {
            me.visual.find('.list, .intervention, .entry').hide();
        }
        return true;
    } catch (ex) { me.writeError('specificInfoHandling', ex); return false }
};

